import { render, staticRenderFns } from "./GroupTraining.vue?vue&type=template&id=3b28fee5&scoped=true"
import script from "./GroupTraining.vue?vue&type=script&lang=js"
export * from "./GroupTraining.vue?vue&type=script&lang=js"
import style0 from "./GroupTraining.vue?vue&type=style&index=0&id=3b28fee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b28fee5",
  null
  
)

export default component.exports